<template>
  <div class="applicant-grid-item" @mouseenter="toggleDetail(true)" @mouseleave="toggleDetail(false)">
    <div class="grid-item-background">
      <div class="grid-item" :style="imageStyle">
        <div class="grid-blur" v-if="isShowDetail"></div>
        <div class="grid-detail">
          <div v-if="isShowDetail">
            <img
              class="icon"
              src="@/client/assets/images/icon_mention.svg"
              v-if="applicant.post.postType === 'mention'"
            /><img
              class="icon"
              src="@/client/assets/images/icon_retweet.svg"
              v-if="applicant.post.postType === 'retweet'"
            /><img
              class="icon"
              src="@/client/assets/images/icon_quote_tweet.svg"
              v-if="applicant.post.postType === 'quote_tweet'"
            /><span class="grid-date">{{ formatDatetime(applicant.post.publishDatetime) }}</span>
            <div class="grid-message" v-html="tweetText(applicant.post.message)"></div>
            <el-popover placement="top" trigger="click" v-model="isShowPopover" @hide="hidePopover">
              <applicant-detail
                :applicant="applicant"
                :snsType="snsType"
                :campaignType="campaignType"
                :isDmSending="isDmSending"
                @change_flag="changeFlag"
                @open_message_history="openMessageHistory"
                @change_ng="changeNg"
              ></applicant-detail>
              <el-button class="el-button--icon grid-button" type="default" slot="reference"
                ><i class="mdi mdi-dots-horizontal"></i
              ></el-button>
            </el-popover>
          </div>
          <applicant-name :applicant="applicant" :isWhite="true" :snsType="snsType"></applicant-name>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.applicant-grid-item {
  display: inline-block;
  width: 20%;
  padding: $spacing-unit;

  .grid-item-background {
    background-image: url('@/client/assets/images/no-photo.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .grid-item {
    position: relative;
    min-height: 27 * $spacing-unit;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border: 1px solid $border-color;
  }

  .grid-message {
    height: 120px;
    overflow-y: auto;
  }

  .grid-date {
    color: #ccc;
  }

  .applicant-name {
    position: absolute;
    bottom: 0;
    z-index: 1;
    padding: $spacing-unit 0;
  }

  .grid-detail {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    padding: $spacing-unit;
    color: $text-color-white;
    overflow-wrap: break-word;

    .icon {
      width: 12px;
      height: 12px;
      margin-right: $spacing-unit;
    }
  }

  .grid-button {
    position: absolute;
    right: $spacing-unit;
    bottom: $spacing-unit;
    z-index: 2;
  }

  .grid-blur {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.75;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import ApplicantDetail from '@/client/components/_atoms/applicant_detail'
import ApplicantName from '@/client/components/_atoms/applicant_name'
import Icon from '@/client/components/_atoms/basic_icon'
import { formatDatetime, formatTweetText } from '@/client/filters/filters'

export default defineComponent({
  components: {
    Icon,
    ApplicantName,
    ApplicantDetail
  },
  props: {
    snsType: 'instagram' | 'twitter' | 'tiktok',
    applicant: Object,
    campaignType: String,
    isDmSending: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowDetail: false,
      isShowPopover: false
    }
  },
  computed: {
    imageStyle() {
      return {
        backgroundImage: `url(${this.applicant.post.mediaUrl || require('@/client/assets/images/no-photo.png')})`
      }
    }
  },
  methods: {
    formatDatetime,

    /**
     * Set show detail
     * @param {boolean} state
     */
    toggleDetail(state: boolean) {
      if (this.isShowPopover) {
        this.isShowDetail = this.isShowPopover
        return
      }

      this.isShowDetail = state
    },

    /**
     * When popover is close
     */
    hidePopover() {
      this.isShowDetail = false
    },

    /**
     * ポストテキストをフォーマット
     * @param {string} text
     * @return {string} フォーマットしたテキスト
     */
    tweetText(text: string): string {
      return formatTweetText(text)
    },

    /**
     * フラグ変更処理
     * @param {{type: string, value: any}} payload
     */
    changeFlag(payload: { type: string; value: any }) {
      this.$emit('change_flag', payload)
    },

    /**
     * メッセージ配信履歴を開く
     * @param {{applicantId: number}} applicantId
     */
    openMessageHistory(payload: { applicantId: number }) {
      this.$emit('open_message_history', payload)
    },

    /**
     * NGアカウント追加/解除
     */
    changeNg(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      this.$emit('change_ng', payload)
    }
  }
})
</script>
